import React, { ReactNode } from 'react';
import { InputGroup, InputLeftElement, InputRightElement, Spinner } from '@chakra-ui/react';

export const FIELD_ADDON_WIDTH = '36px';
export const FIELD_TEXT_OFFSET = '36px';
export const FIELD_HEIGHT = '38px';

interface FieldGroupProps {
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  isLoading?: boolean;
  children: ReactNode;
}

export const FieldGroup = ({ iconLeft, iconRight, isLoading, children }: FieldGroupProps) => (
  <InputGroup alignItems="center">
    {iconLeft && (
      <InputLeftElement
        pointerEvents="none"
        h={FIELD_HEIGHT}
        w={FIELD_ADDON_WIDTH}
        pl="1px"
        color="content.subtle"
        sx={{ '& svg': { display: 'block' } }}
      >
        {iconLeft}
      </InputLeftElement>
    )}
    {children}
    {isLoading ? (
      <InputRightElement pointerEvents="none" h={FIELD_HEIGHT} w={FIELD_ADDON_WIDTH} pr="1px">
        <Spinner size="xs" color="content.subtle" speed="0.6s" />
      </InputRightElement>
    ) : (
      iconRight && (
        <InputRightElement
          pointerEvents="none"
          h={FIELD_HEIGHT}
          w={FIELD_ADDON_WIDTH}
          pr="1px"
          color="content.subtle"
          sx={{ '& svg': { display: 'block' } }}
        >
          {iconRight}
        </InputRightElement>
      )
    )}
  </InputGroup>
);

export const fieldPadding = (hasLeft: boolean, hasRight: boolean) => ({
  pl: hasLeft ? FIELD_TEXT_OFFSET : undefined,
  pr: hasRight ? FIELD_TEXT_OFFSET : undefined,
});
